function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var UnlockFeeTemplate = require('./unlock-fee.template');
var _require = require('./overlay.shell'),
  applyPublishOverlayShell = _require.applyPublishOverlayShell;
var _require2 = require('../unlock_tx_fee'),
  lockUnlockFeeAmount = _require2.lockUnlockFeeAmount,
  canChangeUnlockFee = _require2.canChangeUnlockFee,
  isUnlockEditable = _require2.isUnlockEditable,
  UNLOCK_SIGNED_ERROR = _require2.UNLOCK_SIGNED_ERROR,
  UNLOCK_FEE_LOCKED_ERROR = _require2.UNLOCK_FEE_LOCKED_ERROR;
var _require3 = require('../unlock_tx_edit'),
  parsePositiveSaitoAmount = _require3.parsePositiveSaitoAmount;
var UnlockFeeFlow = /*#__PURE__*/function () {
  function UnlockFeeFlow(app, mod, mainUi) {
    var _this = this;
    _classCallCheck(this, UnlockFeeFlow);
    this.app = app;
    this.mod = mod;
    this.mainUi = mainUi;
    this.overlay = new SaitoOverlay(app, mod, true, true, false);
    this.overlay["class"] = 'saito-overlay rs-publish-overlay-shell';
    this.overlay.clickBackdropToClose = true;
    this.overlay.nonBlocking = false;
    this.step = null;
    this.blockedRoot = null;
    this.onEscapeKey = function (event) {
      if (event.key === 'Escape' && _this.step) {
        _this.hide();
      }
    };
  }
  return _createClass(UnlockFeeFlow, [{
    key: "open",
    value: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var raw, defaultFee;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (isUnlockEditable(this.mod)) {
                _context.n = 1;
                break;
              }
              window.alert(UNLOCK_SIGNED_ERROR);
              return _context.a(2);
            case 1:
              if (canChangeUnlockFee(this.mod)) {
                _context.n = 2;
                break;
              }
              window.alert(UNLOCK_FEE_LOCKED_ERROR);
              return _context.a(2);
            case 2:
              raw = this.app.wallet.convertNolanToSaito(this.app.wallet.default_fee || BigInt(0));
              defaultFee = raw && raw !== '0.00' ? raw : '0.001';
              this.step = 'fee';
              this.show(UnlockFeeTemplate.feeOverlay({
                defaultFee: defaultFee
              }));
              this.bindEvents();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function open() {
        return _open.apply(this, arguments);
      }
      return open;
    }()
  }, {
    key: "show",
    value: function show(html) {
      var _this2 = this;
      document.body.classList.add('rs-publish-modal-open');
      this.blockedRoot = document.querySelector('main.rustscript');
      if (this.blockedRoot) {
        this.blockedRoot.inert = true;
      }
      document.addEventListener('keydown', this.onEscapeKey);
      this.overlay.show(html, function () {
        _this2.onOverlayClosed();
      });
      applyPublishOverlayShell(this.overlay);
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.step) {
        this.overlay.close();
      }
    }
  }, {
    key: "onOverlayClosed",
    value: function onOverlayClosed() {
      document.body.classList.remove('rs-publish-modal-open');
      document.removeEventListener('keydown', this.onEscapeKey);
      if (this.blockedRoot) {
        this.blockedRoot.inert = false;
        this.blockedRoot = null;
      }
      this.step = null;
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _root$querySelector,
        _this3 = this,
        _input$select;
      var root = document.querySelector('.rs-unlock-fee-overlay');
      if (!root) {
        return;
      }
      var errorEl = root.querySelector('.rs-unlock-fee-error');
      var input = root.querySelector('.rs-unlock-fee-amount');
      var showError = function showError(msg) {
        if (!errorEl) {
          return;
        }
        errorEl.textContent = msg || '';
        errorEl.hidden = !msg;
      };
      (_root$querySelector = root.querySelector('[data-action="set-unlock-fee"]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var fee, btn, _this3$mainUi$syncEdi, _this3$mainUi, _this3$mainUi$refresh, _this3$mainUi2, _this3$mainUi3, _this3$mainUi3$render, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              showError('');
              fee = parsePositiveSaitoAmount(input === null || input === void 0 ? void 0 : input.value);
              if (!(fee === null)) {
                _context2.n = 1;
                break;
              }
              showError('Enter a valid fee greater than zero.');
              return _context2.a(2);
            case 1:
              btn = root.querySelector('[data-action="set-unlock-fee"]');
              if (btn) {
                btn.disabled = true;
                btn.textContent = 'Setting Fee…';
              }
              _context2.p = 2;
              _context2.n = 3;
              return lockUnlockFeeAmount(_this3.app, _this3.mod, fee);
            case 3:
              _this3.hide();
              if (!_this3.mainUi) {
                _context2.n = 5;
                break;
              }
              (_this3$mainUi$syncEdi = (_this3$mainUi = _this3.mainUi).syncEditorModes) === null || _this3$mainUi$syncEdi === void 0 || _this3$mainUi$syncEdi.call(_this3$mainUi);
              _context2.n = 4;
              return (_this3$mainUi$refresh = (_this3$mainUi2 = _this3.mainUi).refresh) === null || _this3$mainUi$refresh === void 0 ? void 0 : _this3$mainUi$refresh.call(_this3$mainUi2, {
                skipTestSync: true
              });
            case 4:
              _context2.n = 6;
              break;
            case 5:
              (_this3$mainUi3 = _this3.mainUi) === null || _this3$mainUi3 === void 0 || (_this3$mainUi3 = _this3$mainUi3.panel) === null || _this3$mainUi3 === void 0 || (_this3$mainUi3$render = _this3$mainUi3.render) === null || _this3$mainUi3$render === void 0 || _this3$mainUi3$render.call(_this3$mainUi3);
            case 6:
              _context2.n = 8;
              break;
            case 7:
              _context2.p = 7;
              _t = _context2.v;
              showError((_t === null || _t === void 0 ? void 0 : _t.message) || 'Could not set transaction fee.');
              if (btn) {
                btn.disabled = false;
                btn.textContent = 'Set Transaction Fee';
              }
            case 8:
              return _context2.a(2);
          }
        }, _callee2, null, [[2, 7]]);
      })));
      input === null || input === void 0 || input.focus({
        preventScroll: true
      });
      input === null || input === void 0 || (_input$select = input.select) === null || _input$select === void 0 || _input$select.call(input);
    }
  }]);
}();
module.exports = UnlockFeeFlow;